import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

export default withTranslation()(function CreateFooterNav({ t, step, isLastStep, canGoNext, submitting, onBack, onNext }) {
  return (
    <footer className="flex items-center justify-between border-t border-border-lines px-8 py-5 shrink-0">
      <div>
        {
          step > 0 && (
            <button
              type="button"
              onClick={onBack}
              className="flex items-center gap-1.5 border border-border-lines rounded-full h-11 px-5 text-sm font-medium text-dark-blue"
            >
              <UIcons.UilArrowLeft size={16} /> {t('misc.back')}
            </button>
          )
        }
      </div>

      <button
        type="button"
        onClick={onNext}
        disabled={!canGoNext || submitting}
        className="flex items-center gap-1.5 bg-primary text-white rounded-full h-11 px-5 text-sm font-medium disabled:opacity-40"
      >
        {
          isLastStep
            ? (submitting ? t('rewardAds.createFlow.submitting') : t('rewardAds.create'))
            : <>{t('misc.next')} <UIcons.UilArrowRight size={16} /></>
        }
      </button>
    </footer>
  )
})
